import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { ResultStatus } from "@app/core/models/result-status";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-message-list",
  templateUrl: "./message-list.component.html",
  styleUrls: ["./message-list.component.scss"],
})
export class MessageListComponent implements OnInit {
  messageList = [];
  isDataLoaded = false;

  constructor(
    private router: Router,
    private messageCenterService: MessageCenterService,
    private toaster: ToastrService
  ) {}

  ngOnInit() {
    this.getMessages();
  }

  viewMessage(id) {
    this.router.navigate([`messages/detail/${id}`]);
  }

  getMessages() {
    this.messageCenterService.getMessages().subscribe((result) => {
      this.isDataLoaded = true;
      if (result.Status === ResultStatus.Success) {
        this.messageList = result.Data;
        // this.toaster.success('Please Login to access this page!');

      } else {
        this.messageList = [];
      }
    });
  }
}
